// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"615":"ee661489","812":"209c6bdd"}[chunkId] + ".chunk.js";
};